import PropTypes from "prop-types";

const assignmentPropTypes = PropTypes.shape({
  assignment_classrooms: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
    }),
  ),
  assignment_groups: PropTypes.arrayOf(
    PropTypes.shape({
      group_id: PropTypes.string,
      name: PropTypes.string,
      users: PropTypes.shape({
        first_name: PropTypes.string,
        last_name: PropTypes.string,
        unique_id: PropTypes.string,
      }),
    }),
  ),
  assignment_members: PropTypes.arrayOf(
    PropTypes.shape({
      content_id: PropTypes.string,
    }),
  ),
  assignment_id: PropTypes.number,
  content_id: PropTypes.string,
  created_by: PropTypes.shape({
    user: PropTypes.shape({
      display_name: PropTypes.string,
    }),
  }),
  default_reading_level: PropTypes.number,
  date_due: PropTypes.string,
  grade_level_lock: PropTypes.number,
  instructions: PropTypes.string,
  is_draft: PropTypes.bool,
  is_reading_level_locked: PropTypes.bool,
  title: PropTypes.string,
  version: PropTypes.string,
});

export default assignmentPropTypes;
